<script>
  import { Pie } from 'vue-chartjs'
  import { agrupamentoStatusContratoCores } from '../../../plugins/constants'

  export default {
    extends: Pie,
    props: {
      data: { type: Array, default: () => [1, 1, 1, 1, 1] },
      legenda: { type: Array, default: () => ['sem dados', 'sem dados', 'sem dados', 'sem dados', 'sem dados'] },
      dados: { type: Array }
    },
    mounted () {
      this.dados.sort((a, b) => {
        let sa = a.status.toLowerCase()
        let sb = b.status.toLowerCase()

        if (sa < sb) {
          return -1
        }
        if (sa > sb) {
          return 1
        }
        return 0
      })

      let data_data = this.dados.map(item => item.value)
      let len = this.dados.map(item => item.status)

      // Criação do array de cores baseado no status
      let backgroundColor = this.dados.map(item => agrupamentoStatusContratoCores[item.status] || '#000000')

      this.gradient = this.$refs.canvas
        .getContext('2d')
        .createLinearGradient(0, 0, 0, 450)
      this.gradient2 = this.$refs.canvas
        .getContext('2d')
        .createLinearGradient(0, 0, 0, 450)

      this.gradient.addColorStop(0, 'rgba(255, 0,0, 0.5)')
      this.gradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)')
      this.gradient.addColorStop(1, 'rgba(255, 0, 0, 0)')

      this.gradient2.addColorStop(0, 'rgba(0, 231, 255, 0.9)')
      this.gradient2.addColorStop(0.5, 'rgba(0, 231, 255, 0.25)')
      this.gradient2.addColorStop(1, 'rgba(0, 231, 255, 0)')

      this.renderChart(
        {
          labels: len,
          datasets: [
            {
              backgroundColor: backgroundColor,
              data: data_data
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            labels: {
              fontColor: 'black',
              fontSize: 18
            },
            position: 'top'
          }
        }
      )
    }
  }
</script>
